import React, { useRef } from "react";
import { CustomerCaptureOverlay } from "web/react/components/customer-capture-overlay/customer-capture-overlay";
import { FeatureArticleBlocks } from "web/react/components/feature-article/feature-article-blocks";
import { FeatureArticleHeader } from "web/react/components/feature-article/feature-article-header";
import { FeatureArticleSummary } from "web/react/components/feature-article/feature-article-summary";
import { FeatureArticlePayload } from "web/react/components/feature-article/types";
import { ProductOverlay } from "web/react/components/product-overlay";
import { VStack } from "web/react/emo/v-stack";
import * as styles from "./feature-article.css";

interface FeatureArticleProps {
    feature_article: FeatureArticlePayload;
}

export function FeatureArticle({ feature_article }: FeatureArticleProps): React.ReactElement {
    const { meta, header, hero, summary, body } = feature_article;

    const overlayRef = useRef(null);

    return (
        <>
            <CustomerCaptureOverlay />
            <div ref={overlayRef}>
                <ProductOverlay parentRef={overlayRef} pageType="editorial" />
            </div>
            <div className={styles.page}>
                <article className={styles.shell}>
                    <VStack spacing="lg">
                        <FeatureArticleHeader
                            header={header}
                            hero={hero}
                            disclosure={meta.sponsored ? meta.disclosure : null}
                        />

                        {summary && (
                            <FeatureArticleSummary title={summary.title} body={summary.body} />
                        )}
                        <FeatureArticleBlocks blocks={body} isSponsored={meta.sponsored} />
                    </VStack>
                </article>
            </div>
        </>
    );
}
